import React, { useEffect } from 'react';
import './AdSense.css';

declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

interface AdSenseProps {
  adClient: string;
  adSlot: string;
  adFormat?: 'auto' | 'horizontal' | 'vertical';
  fullWidthResponsive?: boolean;
}

const AdSense: React.FC<AdSenseProps> = ({
  adClient,
  adSlot,
  adFormat = 'auto',
  fullWidthResponsive = false,
}) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // adsbygoogle not available in this environment (e.g., dev without real client ID)
    }
  }, []);

  return (
    <ins
      className="adsbygoogle adsense-block"
      data-ad-client={adClient}
      data-ad-slot={adSlot}
      data-ad-format={adFormat}
      {...(fullWidthResponsive ? { 'data-full-width-responsive': 'true' } : {})}
    />
  );
};

export default AdSense;
